<app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

<div class="flex justify-between mt-5">
    <h2 class="font-medium">{{'USER.USER' | translate}} </h2>
    <button *ngIf="!disableModeUpsertUser" (click)="router.navigate(['/admin/users/add'])" color="primary"
        mat-flat-button>
        <mat-icon>add</mat-icon>
        {{'COMMON.ADD_NEW' | translate}}
    </button>
</div>

<div class="mt-5">
    <form class="example-form" [formGroup]="filterForm" (ngSubmit)="onSubmit()">
        <div class="example-container">
            <mat-form-field class="me-3">
                <mat-label>{{'COMMON.FIRST_NAME' | translate}}</mat-label>
                <input formControlName="firstName" class="border-transparent focus:border-transparent focus:ring-0"
                    matInput placeholder="First name">
            </mat-form-field>
            <mat-form-field class="me-3">
                <mat-label>{{'COMMON.LAST_NAME' | translate}}</mat-label>
                <input formControlName="lastName" class="border-transparent focus:border-transparent focus:ring-0"
                    matInput placeholder="Last name">
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'COMMON.USER_NAME' | translate}}</mat-label>
                <input formControlName="loginName" class="border-transparent focus:border-transparent focus:ring-0"
                    matInput placeholder="User name">
            </mat-form-field>
            <button type="submit" mat-fab extended class="ms-3" color="primary">
                <mat-icon>search</mat-icon>
                {{'COMMON.SEARCH' | translate}}
            </button>
        </div>
    </form>
</div>

<div class="mt-3">
    <div class="flex justify-end items-baseline">
        <button class="me-5" [hidden]="isHiddenCustomDate" mat-raised-button (click)="openDialogFilterCustomDate()">
            <mat-icon class="me-2">date_range</mat-icon>
            {{'COMMON.SELECT_DATE' | translate}}
        </button>
        <mat-form-field>
            <mat-label>{{'COMMON.FILTER' | translate}} ({{'COMMON.DATE_ACCESSED' | translate}})</mat-label>
            <mat-select (selectionChange)="filterUser($event.value)">
                <mat-option *ngFor="let filter of filterList" [value]="filter.stringQuery">
                    {{ filter.text | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<div class="mt-5" style="width: 100%; overflow-x: auto;">
    <table mat-table style="width: 100%; min-width: 600px;" class="ws-table" [dataSource]="dataSource" matSort
        (matSortChange)="announceSortChange($event)">

        <!-- Position Column -->
        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">
                {{'COMMON.FIRST_NAME' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
                {{'COMMON.LAST_NAME' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="departmentName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by weight">
                {{'DEPARTMENTS.DEPARTMENT' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.departmentName}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by symbol">
                {{'COMMON.USER_NAME' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.username}} </td>
        </ng-container>

        <ng-container matColumnDef="loginDomain">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by symbol">
                Login Domain
            </th>
            <td mat-cell *matCellDef="let element"> {{element.loginDomain}} </td>
        </ng-container>

        <ng-container matColumnDef="lastAccessedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by symbol">
                {{'COMMON.DATE_ACCESSED' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.lastAccessedDate | dateFormat }} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element">
                <button class="!text-[#00000099]" [routerLink]="['/admin/users/edit', element.id]"
                    mat-button><mat-icon>edit</mat-icon></button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <qms-paginator [length]="totalCount >= 0 ? totalCount : 0" [pageSize]="filter.pageSize"
        [pageSizeOptions]="[10, 25, 100]" (page)='pageEvent($event)' [size]='"medium"'>
    </qms-paginator>

</div>